// extracted by mini-css-extract-plugin
module.exports = {"box":"Account_box__3cgpi"};